import * as React from 'react';
import styled from 'styled-components';

type Props = {
  srcDesktop?: string;
  srcMobile?: string;
};

const SectionRoot = styled.section<{ srcMobile?: string; srcDesktop?: string }>(
  ({ theme }) => ({
    width: '100%',
    backgroundColor: theme.blue15,
    position: 'relative',
    padding: theme.spacing(),
  })
);

const SectionImg = styled.div<{ srcMobile?: string; srcDesktop?: string }>(
  ({ srcMobile, srcDesktop }) => ({
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: 1,
    pointerEvents: 'none',
    backgroundImage: srcMobile ? `url("${srcMobile}")` : '',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    '@media screen and (min-width: 768px)': {
      backgroundImage: srcDesktop ? `url("${srcDesktop}")` : '',
    },
  })
);

const BlocksRoot = styled.div({
  width: '100%',
  height: '100%',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'center',
});

const Section: React.FC<Props> = ({ srcDesktop, srcMobile, children }) => (
  <SectionRoot>
    <SectionImg srcDesktop={srcDesktop} srcMobile={srcMobile} />
    <BlocksRoot>{children}</BlocksRoot>
  </SectionRoot>
);

export default Section;
